import React from 'react';

/**
 * Icônes FontAwesome Pro v7 duotone, rendues inline pour respecter currentColor.
 *
 * Les SVG duotone FA v7 ont 2 <path> en `fill="currentColor"` : le secondaire
 * porte `opacity=".4"`, le primaire est plein. En posant `color` sur le wrapper,
 * on obtient le rendu duotone classique (primaire plein + secondaire à 40%).
 * Source : ~/Developpement/Fontawesome/duotone (pack Pro), copiés dans assets/duotone.
 */
const RAW = import.meta.glob('../../../assets/duotone/*.svg', {
  query: '?raw',
  import: 'default',
  eager: true,
}) as Record<string, string>;

const BY_NAME: Record<string, string> = {};
for (const [path, svg] of Object.entries(RAW)) {
  const name = path.split('/').pop()!.replace('.svg', '');
  BY_NAME[name] = svg;
}

interface Props {
  name: string;
  size?: number;
  className?: string;
}

export function DuotoneIcon({ name, size = 28, className }: Props) {
  const svg = BY_NAME[name];
  if (!svg) return null;
  return (
    <span
      className={className}
      aria-hidden="true"
      style={{ display: 'inline-flex', width: size, height: size, lineHeight: 0 }}
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
}
